<template>
	<div :style="$grid('200px-300px-1')">
		<span> Relationship To Customer? </span>

		<InputRichDropdown
			v-model:saturn="props.customerInfo.relationship"
			:list="filteredCustomerRelationships"
			:valueMap="(x: ToListItems<CustomersRelationship>) => x.value"
			:display="(x: ToListItems<CustomersRelationship>) => x.display"
			label="Customers Relationship"
			@change="handleChange"
			nothingSelected="Select relationship"
			:invalid="!!validation?.customersInfo.relationship?.$silentErrors?.length"
		>
			<template
				#validation
				v-if="!!validation?.customersInfo.relationship?.$silentErrors?.length"
			>
				{{ validation?.customersInfo.relationship.$silentErrors[0]?.$message }}
			</template>
		</InputRichDropdown>

		<InputTextbox
			v-if="props.customerInfo.relationship == CustomersRelationship.Other"
			label="Relationship Description"
			v-model:saturn="props.customerInfo.relationshipDescription"
			placeholder=""
			:invalid="!!validation?.customersInfo.relationshipDescription?.$silentErrors?.length"
		>
			<template
				#validation
				v-if="!!validation?.customersInfo.relationshipDescription?.$silentErrors?.length"
			>
				{{ validation?.customersInfo.relationshipDescription.$silentErrors[0].$message }}
			</template>
		</InputTextbox>
	</div>
</template>
<script lang="ts">
	export interface ICustomerRelationshipCRUDProps {
		customerInfo: FIMenuCustomersInfo;
		validation: any;
		areAnyOfTheCustomersABusiness: boolean;
	}
</script>
<script setup lang="ts">
	// Classes & Interfaces
	import { CustomersRelationship } from '@core/classes/SharedEnums';
	import { FIMenuCustomersInfo } from '@core/classes/FIMenuCustomersInfo';

	// Helpers
	import { computed } from 'vue';
	import CustomersRelationshipHelper from '@core/_enums/CustomerRelationshipEnumsHelper';
	import { ToListItems } from '@core/helpers/enum-helper';

	// Components
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import InputTextbox from '@core/components/InputTextbox.vue';

	const props = defineProps<ICustomerRelationshipCRUDProps>();

	// Compute filtered list based on isBusiness flag
	const filteredCustomerRelationships = computed(() => {
		return CustomersRelationshipHelper.getFilteredList(props.areAnyOfTheCustomersABusiness);
	});

	const handleChange = (newStatus: CustomersRelationship) => {
		if (newStatus != CustomersRelationship.Other) props.customerInfo.relationshipDescription = null;
	};
</script>
<style scoped></style>
